import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { Observable, Subject } from "rxjs";
import { HeaderFactoryService } from "./header-factory.service";
import { ConfigService } from "./config.service";
import { ProfileService } from "./profile.service";
import { QuestionInfo, SelectedProduct } from "common";



@Injectable()
export class QuestionsService {
  constructor(
    private httpsClient: HttpClient,
    private headerService: HeaderFactoryService,
    private configService: ConfigService,
    private profileService: ProfileService
  ) { }

  public getQuestions(stateOfIssue = ""): Observable<QuestionInfo[]> {
    let profile = this.profileService.getUserProfile();
    let state = stateOfIssue;
    if (!state) {
      state = profile.StateCode
    }
    // get questions
    return this.httpsClient.get<QuestionInfo[]>(
      `${this.configService.apiUrl}api/v${this.configService.apiVersion
      }/resource/Questions?state=${state}&program=${profile.Program}`,
      this.headerService.getAuthorizationHeaderOptions(["ClientCMS", "ParentCMS", "Culture", "program"])
    );
  }
  public resetForm = new Subject<{ isRefreshRequired?: boolean }>();
}
